import styles from '@mathflat/common/style'
import s3URL from '@mathflat/common/util/s3'

import { Icon } from '@/component/atoms/Icon'
import modalService from '@/service/modal.service'
import type { StyleProps } from '@/types'

import S from './AutoMarkableGuide.style'

const {
  colors: { gray, blue },
} = styles

type Props = {
  type: 'recommend' | 'practiceTest' | 'makeWorksheet' | 'makeWorkbook'
  variant?: 'text' | 'icon'
} & StyleProps

const AutoMarkableGuide = ({ type, variant = 'text', style, className }: Props) => {
  const handleTooltip = () => {
    modalService.openModal(
      <div>
        <img
          width={972}
          height={634}
          src={`${s3URL.mathflatAssetsBucket.teacher('assets/images/autoMarkable-guide.png')}`}
          alt="autoMarkable guide"
        />
      </div>,
    )
  }

  if (variant === 'icon') {
    return (
      <button
        type="button"
        css={S.iconButton}
        style={style}
        className={className}
        onClick={handleTooltip}
      >
        <Icon name="info_fill" size={18} color={gray.$500} />
      </button>
    )
  }

  return (
    <div style={style} css={S.basic} className="auto-markable-guide">
      <button
        css={S.text}
        style={{
          color: type === 'makeWorksheet' || type === 'makeWorkbook' ? blue.$400 : gray.$700,
        }}
        onClick={handleTooltip}
      >
        자동 채점이란?
      </button>
    </div>
  )
}

export default AutoMarkableGuide
